import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';

// Angular Material
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';

import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { AuthentificationModule } from './authentification/authentification.module';
import { CoreModule } from './core/core.module';
import { HttpErrorHandlerInterceptor } from './core/http-error-handler.interceptor';
import { HttpSpinnerInterceptor } from './core/http-spinner.interceptor';
import { NavbarComponent } from './navbar/navbar.component';
import { SaisieModule } from './saisie/saisie.module';
import { SharedModule } from './shared/shared.module';
import { SuiviSaisieModule } from './suivi-saisie/suivi-saisie.module';
// Import des variables d’environnements utiles
import { registerLocaleData } from '@angular/common';
import localeFr from '@angular/common/locales/fr';
import { environment } from 'src/environments/environment';
import { AccessibiliteComponent } from './accessibilite/accessibilite.component';

registerLocaleData(localeFr, 'fr');

@NgModule({
  declarations: [
    AppComponent,
    NavbarComponent,
    AccessibiliteComponent
  ],
  imports: [
    AuthentificationModule,
    BrowserModule,
    SuiviSaisieModule,
    SaisieModule,
    SharedModule,
    CoreModule,
    AppRoutingModule,
    // Angular Material
    BrowserAnimationsModule,
    MatProgressSpinnerModule,
    MatSnackBarModule
  ],
  providers: [
    // Variable d’environnement
     {
        provide: 'API_URL', useValue: environment.apiUrl
     },
     {
        provide: 'AUTH_URL', useValue: environment.authUrl
     },

    // Gestion du spinner
     {
       provide: HTTP_INTERCEPTORS,
       useClass: HttpSpinnerInterceptor,
       multi: true,
     },
     {
      provide: HTTP_INTERCEPTORS,
      useClass: HttpErrorHandlerInterceptor,
      multi: true,
     }
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
